module.exports = __webpack_public_path__ + "img/menu_order.4850cc79.svg";